import { useState } from "react";
import React from "react";

import dayjs from "dayjs";
import JDate from "jalali-date";
import Container from "./index-css";
const Index = ({ data }) => {
  const [showMore1, setShowMore1] = useState(false)
  const [showMore2, setShowMore2] = useState(false)
  const [showMore3, setShowMore3] = useState(false)

  let extra = []
  try {
        extra = JSON.parse(data.data[0].request_firehome_exterafield)
  } catch (e) {
        console.error(e)
        extra = []
  }

  function formatPrice(value) {
        return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  }

  let arrPrice = []
  try {
        arrPrice = JSON.parse(data.data[0].jsonpricing_text)
        if (arrPrice.instalment_conditions) {
              let cash = arrPrice.instalment_conditions.filter((c) => c.instalment_conditions_mode_id === "0")
              let check = arrPrice.instalment_conditions.filter((c) => (c.instalment_conditions_mode_id === "1" || c.instalment_conditions_mode_id === "3"))
        }
  } catch (e) {
        console.log(e)
  }
  let active_star =
        parseInt(arrPrice.company_customer_satisfaction) +
        parseInt(arrPrice.company_levelof_prosperity) +
        parseInt(arrPrice.company_timeanswer_complaints)

  active_star = Math.ceil(active_star / 3 / 2)
  let deactive_star = 5 - active_star
  const Stars = () => {
        let stars = []
        for (let i = 0; i < active_star; i++) {
              stars.push(<img src="/imagess/star.png" key={i + deactive_star} alt="icon star" />)
        }
        return <>{stars}</>
  }

  const Stars_ = () => {
        let dstars = []
        for (let i = 0; i < deactive_star; i++) {
              dstars.push(<img src="/imagess/star_.png" key={i} alt="icon rating" />)
        }
        return <>{dstars}</>
  }

  const handleClick = (id) => {
        if (id === 1) {
              setShowMore1(!showMore1)
        } else if (id === 2) {
              setShowMore2(!showMore2)
        } else if (id === 3) {
              setShowMore3(!showMore3)
        }
  }
  // *******************component************component*******************component*****************component*************

  const Text = (props) => {
    return (
      <Container>
        <div  className="main-textt">
          <div className="text-title">{props.title}:</div>
          <div className="text-detail">{props.detail}</div>
        </div>
      </Container>
    );
  };

  const Linetitle = (props) => {
    return (
      <Container>
        <div className="main-line">
          <div style={{ width: "100%" }} className="line">
            <div style={{ width: props.w }} className="line-text">
              {props.name}
            </div>
          </div>
        </div>
      </Container>
    );
  };
  return (
    <Container>
      <div className="main-map-detail">
      <div className="title">
              خلاصه سفارش بیـــمه
              <span
                style={{
                  color: "#1ad4a3",
                  marginRight: "5px",
                  display: "flex",
                }}
              >
          کرونا
              </span>
            </div>
        <Linetitle name="اطلاعات فرد" />
        <div className="map-detail-divv">
          <Text title="سن بیمه شده" detail={data.data[0].corona_old_name} />
          <Text title="مدت بیمه نامه" detail={data.data[0].corona_time_name} />
         
        </div>

        <Linetitle name="پوشش های اضافی" />
        <div className="map-detail-divv">
          <Text
            title="پوشش"
            detail={data.data[0].corona_coverage_name}
          />
       
        </div>

        <Linetitle name="اطلاعات بیمه" />
        <div className="map-detail-divv">
          <Text title="نام بیمه" detail={arrPrice.company_name} />
          <Text title="امتیاز بیمه" detail={arrPrice.company_levelof_prosperity} />
          <Text
            title="مبلغ بیمه"
            detail={`${formatPrice(arrPrice.price)} ریال`}
          />
          <Text
            title="درصد تخفیف مدیریتی"
            detail={
              arrPrice.managdiscount_amount
                ? `${arrPrice.managdiscount_amount} درصد`
                : "ندارد"
            }
          />

  
          <Text
            title="امکان خرید اقساطی"
            detail={arrPrice.instalment_conditions ? "بله" : "خیر"}
          />
          <>
          {arrPrice.instalment_conditions && arrPrice.instalment_conditions.map((data) => (
              <Text
                title={data.instalment_conditions_desc}
                detail={data.instalment_conditions_amount}
              />
            ))}
          </>

        </div>
      </div>
    </Container>
  );
};

export default Index;
